import { useState, useEffect, useCallback } from 'react';
import {
  type AtaImagem,
  getAtaImagens,
} from '../../../services/ataImagem.service';

interface UseAtaImagensParams {
  ataId: string;
}

interface UseAtaImagensReturn {
  imagens: AtaImagem[];
  loading: boolean;
  setImagens: (imagens: AtaImagem[]) => void;
  refetch: () => Promise<void>;
}

export function useAtaImagens({ ataId }: UseAtaImagensParams): UseAtaImagensReturn {
  const [imagens, setImagens] = useState<AtaImagem[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchImagens = useCallback(async () => {
    if (!ataId) return;
    
    try {
      setLoading(true);
      const data = await getAtaImagens(ataId);
      setImagens(data);
    } catch (error) {
      console.error('Erro ao carregar imagens:', error);
      setImagens([]);
    } finally {
      setLoading(false);
    }
  }, [ataId]);

  useEffect(() => {
    fetchImagens();
  }, [fetchImagens]);

  return {
    imagens,
    loading,
    setImagens,
    refetch: fetchImagens,
  };
}
